export const EVENT_KEY_NAME = '$track_get_started_modal_click'

export const KNOWLEDGE_BASE_URL = 'https://support.careerminds.com/'
